import { ClinicalItemLog } from '@features/components/ClinicalData/types';
import { RadiometerLayout } from '@features/components/ClinicalData/components/ClinicalLog/components/RadiometerLayout';
import { Gallery } from '@features/components/ClinicalData/components/ClinicalLog/components/Gallery';
import { getPfRatioInSituData } from '@features/components/ClinicalData/components/ClinicalLog/LogItems/utils';
import { ClinicalDataNameValue } from '@features/components/ClinicalData/components/ClinicalLog/LogItems/types';
import { ClinicalItemType } from '@/api/apis/case';
import { MeasurementRow } from '../components/MeasurementRow';

type PfRatioInSituProps = {
  event: string;
  item: ClinicalItemLog<ClinicalItemType.PFRatioInSitu>;
  onShareClick?: () => void;
  isTrialCase: boolean;
  shared?: boolean;
};

export const PfRatioInSitu = ({ event, item, onShareClick, isTrialCase, shared }: PfRatioInSituProps) => {
  const pfRatioInSituData = getPfRatioInSituData(item, isTrialCase);

  return (
    <RadiometerLayout
      shared={shared}
      onShareClick={onShareClick}
      event={event}
      measurements={pfRatioInSituData.commonMeasurements}
    >
      <div className="flex flex-col gap-1">
        {pfRatioInSituData.data.map(({ name, value }: ClinicalDataNameValue) => (
          <MeasurementRow label={name} value={value} key={name} />
        ))}
        <Gallery heading={event} mediaFiles={item.mediaFiles} onShareClick={onShareClick} isFromClinicalLog />
      </div>
    </RadiometerLayout>
  );
};
